import { useContext } from 'react';

import { HistoryContext } from './context';

export const useHistoryRoutesStack = () => {
  const { routeStack } = useContext(HistoryContext);

  return routeStack;
};
